import { useNavigate } from 'react-router-dom-v6'

import { UserForm, type UserFormValues } from '../components/UserForm'
import { useRegisterUser } from '../hooks'

// Sends the user an email invite: the form collects no password, so the
// wire request carries password=null, which the IDP treats as "send a
// set-password link" (see userTransformer.toRegisterRequest).
export function InviteUser() {
  const navigate = useNavigate()
  const { mutateAsync: register } = useRegisterUser()

  const onSubmit = async (values: UserFormValues) => {
    await register(values)
    navigate('/users', { replace: true })
  }

  return <UserForm mode="invite" onSubmit={onSubmit} />
}
